export default "__VITE_ASSET__C587Lb9U__"